import { Auth } from 'aws-amplify';
import { CognitoUser } from 'amazon-cognito-identity-js';
import sendMessage from './sendMessage';
import { JWT_SESSION } from './constants';

export default async (user?: CognitoUser): Promise<void> => {
  const session = user ? await Auth.userSession(user) : await Auth.currentSession();
  const accessToken = session.getAccessToken().getJwtToken();
  const idToken = session.getIdToken().getJwtToken();
  const refreshToken = session.getRefreshToken().getToken();
  sendMessage(JWT_SESSION, { accessToken, idToken, refreshToken });
};
